import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClientService {

    async getCompanyClients(companyId) {
        return await axios.get(`/api/client1/${companyId}`, {headers: authHeader()})
    }

    async getBasicCompanyClientsLazyLoading(companyId, params, search, filters) {

        const newParams = {};

        newParams.sort  = params.sortField || 'name';
        newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

        newParams.page = params.first / params.rows + 1;
        newParams.size = params.rows;

        if (search) {
            newParams.search = search;
        }

        if (filters) {
            newParams.filters = filters;
        }

        var apiString = `/api/client1/basic/lazyloading/${companyId}`;

        console.log("[ClientService][getBasicCompanyClientsLazyLoading] ",
            "page =", newParams.page,
            ", size =", newParams.size,
            ", sort =", newParams.sort,
            ", order =", newParams.order,
            ", search =", newParams.search,
            ", filters =", newParams.filters,
            ", API =", apiString);

        try {
            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[ClientService][getBasicCompanyClientsLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }


    async getBasicCompanyClients(companyId) {
        // return await axios.get(`/api/client1/basic/${companyId}`, {headers: authHeader()})
        return await axios.get(`/api/client1/all/${companyId}`, {headers: authHeader()})
    }

    async getPendingCompanyClients(companyId) {
        return await axios.get(`/api/client1/pending/${companyId}`, {headers: authHeader()})
    }

    async searchCompanyClients(companyId, clientName) {
        return await axios.get(`/api/client1/${companyId}/${clientName}`, {headers: authHeader()})
    }

    async searchCompanyCategoryClients(companyId, clientName) {
        return await axios.get(`/api/client1/${companyId}/category/${clientName}`, {headers: authHeader()})
    }

    async getCompanyAffiliateClients(companyId, clientId) {
        return await axios.get(`/api/client1/${companyId}/affiliate/${clientId}`, {headers: authHeader()})
    }

    async searchCompanyClientsActive(companyId, clientName) {
        return await axios.get(`/api/client1/active/${companyId}/${clientName}`, {headers: authHeader()})
    }

    async getClient(clientId) {
        return await axios.get(`/api/client1/specific/${clientId}`, {headers: authHeader()})
    }

    async getClientDetail(clientId) {
        return await axios.get(`/api/client1/detail/${clientId}`, {headers: authHeader()})
    }

    async getClientForUser(userId) {
        return await axios.get(`/api/client1/user/${userId}`, {headers: authHeader()})
    }

    async createClient(companyId, data) {
        return await axios.post(`/api/client1/${companyId}`, data, {headers: authHeader()});
    }

    async createClientHealthcareInsurance(companyId, providerId, memberNumber) {
        return await axios.post(`/api/client1/healthcare/${companyId}/${providerId}/${memberNumber}`, null, {headers: authHeader()});
    }

    async updateHealthcareInsuranceDetails(companyId, clientId) {
        return await axios.post(`/api/client1/healthcare/update/${companyId}/${clientId}`, null, {headers: authHeader()});
    }
    async createClientBooking(companyId, data) {
        return await axios.post(`/api/client1/booking/${companyId}`, data, {headers: authHeader()});
    }

    async processClientIntake(companyId, data) {
        console.log("[ClientService][processClientIntake] Before calling back-end API. data = ", data);
        console.log("[ClientService][processClientIntake] Before calling back-end API. companyId = ", companyId);

        return await axios.post(`/api/client1/clientintake/${companyId}`, data);
    }

    async updateClient(clientId, data) {
        return await axios.put(`/api/client1/${clientId}`, data, {headers: authHeader()});
    }

    async deleteClient(clientId) {
        return await axios.delete(`/api/client1/${clientId}`, {headers: authHeader()})
    }

    async removeProductFromClient(clientId, productId) {
        return await axios.put(`/api/client1/${clientId}/product/delete/${productId}`, null, {headers: authHeader()});
    }

    async sendClientEmail(clientId, formData) {
        return await axios.post(`/api/client1/email/${clientId}`,
            formData,
            {headers: authHeader(), "Content-Type": "multipart/form-data"});
    }

    async sendClientSms(clientId, data) {
        return await axios.post(`/api/client1/sms/${clientId}`, data, {headers: authHeader()});
    }

    async sendClientWhatsapp(clientId, data) {
        return await axios.post(`/api/client1/whatsapp/${clientId}`, data, {headers: authHeader()});
    }

    async sendBookingLink(clientId) {
        return await axios.post(`/api/client1/bookinglink/${clientId}`, null, {headers: authHeader()});
    }

    async sendDigitalFormLink(clientId, digitalFormId) {
        console.log('[ClientService][sendDigitalFormLink] clientId = ', clientId);
        console.log('[ClientService][sendDigitalFormLink] digitalFormId = ', digitalFormId);

        return await axios.post(`/api/client1/digitalform/${clientId}/${digitalFormId}`, null, {headers: authHeader()});
    }

    async sendClientUnpaid(clientId, data) {
        return await axios.post(`/api/client1/unpaid/${clientId}`, data, {headers: authHeader()});
    }

    async getClientConfiguration(clientId) {
        console.log("[ClientService][getClientConfiguration] Before getting client configuration. Client ID = ", clientId);
        return await axios.get(`/api/clientconfig/${clientId}`, {headers: authHeader()})
    }

    async updateClientConfiguration(clientId, data) {
        console.log("[ClientService][updateClientConfiguration] Before updating client configuration back-end API call. Data = ", data);
        return await axios.put(`/api/clientconfig/${clientId}`, data, {headers: authHeader()});
    }

    async updateClientAuditTrail(clientId, data) {
        console.log("[ClientService][updateClientAuditTrail] Before calling back-end API. Data = ", data);

        return await axios.post(`/api/client1/audittrail/${clientId}`, data, {headers: authHeader()});
    }

    async convertSiClientToAppUser(clientId) {
        return await axios.post(`/api//user/convert/client/si/app/${clientId}`, null, {headers: authHeader()});
    }

    async convertSiClientToPodcastUser(clientId) {
        return await axios.post(`/api//user/convert/client/si/podcast/${clientId}`, null, {headers: authHeader()});
    }

    async convertSiClientToCourseUser(clientId) {
        return await axios.post(`/api//user/convert/client/si/course/${clientId}`, null, {headers: authHeader()});
    }

    async emailStatement(clientId, type, startDate, endDate, bankAccountId) {
        return await axios.post(`/api/statement/email/${clientId}?type=${type}&startDate=${startDate}&endDate=${endDate}&bankAccountId=${bankAccountId}`, null,{ headers: authHeader() });
    }

    async downloadStatement(clientId, type, startDate, endDate, bankAccountId) {
        return await axios.get(`/api/statement/download/${clientId}?type=${type}&startDate=${startDate}&endDate=${endDate}&bankAccountId=${bankAccountId}`, {
            headers: authHeader(),
            responseType: 'blob', // Set the responseType to 'blob'
        });
    }

    async exportClientInfo(companyId) {
        return await axios.get(`/api/client1/export/${companyId}`, {
            headers: authHeader(),
            responseType: 'blob', // Set the responseType to 'blob'
        });
    }

    async exportImportTemplate(companyId) {
        return await axios.get(`/api/client1/export/importtemplate/${companyId}`, {
            headers: authHeader(),
            responseType: 'blob', // Set the responseType to 'blob'
        });
    }

    async processBulkSms(companyId, message) {
        return await axios.post(`/api/client1/bulksms/${companyId}/${message}`, null,{ headers: authHeader() });
    }


    async createSiClient(data) {
        return await axios.post(`/api/client1/si/initialise`, data);
    }

    async upgradeSiClient(data) {
        return await axios.post(`/api/client1/si/upgrade`, data);
    }

    async processCancellationSiClient(companyId, email, reason) {
        return await axios.post(`/api/client1/si/cancellation/${companyId}/${encodeURIComponent(email)}/${reason}`, null, { headers: authHeader() });
    }

}

export default new ClientService();
